import { z } from 'zod';

import { type ValidationMessageSet } from '../../form-validations';
import { getCaptchaTokenSchema } from '../../schemas/captcha-token-schema';
import { getEmailSchema } from '../../schemas/email-schema';
import {
  type NameValidationMessages,
  getNameSchema,
} from '../../schemas/name-schema';
import { getPhoneSchema } from '../../schemas/phone-schema';

export const formReferrerMap = {
  graduates: 'Post Job Vacancy',
  htd: 'HTD',
  reskilling: 'Training',
} as const;

type Messages = {
  companyRequiredMessage: string;
  emailValidationMessages: ValidationMessageSet;
  errorMessage: string;
  firstNameValidationMessages: NameValidationMessages;
  hiringLocationRequiredMessage: string;
  jobPostingInvalidMessage: string;
  lastNameValidationMessages: NameValidationMessages;
  legalTextRequiredMessage: string;
  messageRequiredMessage: string;
  phoneInvalidMessage: string;
  phoneRequiredMessage: string;
  roleRequiredMessage: string;
};

// Validation shared between client form & API payload
export const getBaseSchema = (messages?: Messages) =>
  z.object({
    company: z.string().max(80).min(2, messages?.companyRequiredMessage),
    message: z.string().min(10, messages?.messageRequiredMessage),
    role: z.string().min(1, messages?.roleRequiredMessage),
  });

// Validation for client form only
export const getB2bSchema = (messages: Messages) =>
  z
    .object({
      acceptedTerms: z.literal<boolean>(true, {
        errorMap: () => ({ message: messages.legalTextRequiredMessage }),
      }),
      hiringLocation: z.string().min(1, messages.hiringLocationRequiredMessage),
      jobPosting: z
        .string()
        .max(255)
        .url(messages.jobPostingInvalidMessage)
        .optional()
        .or(z.literal('')),
      phone: getPhoneSchema(messages),
    })
    .merge(getBaseSchema(messages))
    .merge(getCaptchaTokenSchema({ requiredMessage: messages.errorMessage }))
    .merge(getEmailSchema(messages.emailValidationMessages))
    .merge(
      getNameSchema(
        messages.firstNameValidationMessages,
        messages.lastNameValidationMessages
      )
    )
    .required();
